import React, { PropsWithChildren } from "react";
import { ErrorInfo } from "react";
import { withIntl, IntlProps } from "context/Intl";
import { Link } from "react-router-dom";
import { ROUTES } from "routes";

interface StateInterface {
    hasError: boolean;
    error?: Error;
    errorInfo?: ErrorInfo;
}

class ErrorBoundary extends React.Component<PropsWithChildren<IntlProps>, StateInterface> {
    state = {
        hasError: false,
    };

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.setState({
            hasError: true,
            error: error,
            errorInfo: errorInfo,
        });
    }

    render() {
        if (this.state.hasError) {
            const { intl } = this.props;
            return (
                <React.Fragment>
                    <div className="container text-center padding-top--10">
                        <h2 className="text-color--primary">{intl.formatMessage("generic.error")}</h2>
                        <h3 className="margin-top--1 margin-bottom--2">{intl.formatMessage("generic.error.subtitle")}</h3>
                        <Link className="btn btn--secondary" reloadDocument to={ROUTES.HOME}>
                            {intl.formatMessage("our_services.confirm.label.back_home_page")}
                        </Link>
                    </div>
                </React.Fragment>
            );
        }
        return this.props.children;
    }
}

export default withIntl(ErrorBoundary);
